import {axios, CancelTokenSource} from '../axios';
import { baseEnvironment } from '../environment/environment.base';

const v3Version = baseEnvironment.apiVersion3;
const getAllSurgeonsRoute = `${v3Version}${baseEnvironment.apiEndPoints.surgeryDetailsScreen.getAllSurgeons}`
const surgeonByIdRoute = `${v3Version}${baseEnvironment.apiEndPoints.surgeryDetailsScreen.getSurgeryDetailsBySurgeonId}`
const updateSurgeonPreferencesRoute = `${v3Version}${baseEnvironment.apiEndPoints.surgeryDetailsScreen.updateSurgeonPreferences}`
const profilePictureRoute = `${v3Version}${baseEnvironment.apiEndPoints.surgeryDetailsScreen.getProfilePictureBySurgenId}`
const getServiceLinesRoute = `${v3Version}${baseEnvironment.apiEndPoints.surgeryDetailsScreen.getServiceLines}`

export const getAllSurgeons = async (
  offSet: number,
  selectedServiceLine?: string,
  searchText?: string,
  cancelToken?: CancelTokenSource['token']
): Promise<any> => {
  try {
    let params = `?offset=${offSet}`;
    if (searchText) {
      params += `&search_text=${searchText}`;
    }
    if (selectedServiceLine) {
      params += `&service_line_id=${selectedServiceLine}`;
    }
    const response = await axios.get(`/${getAllSurgeonsRoute}${params}`, {cancelToken});
    return response.data;
  } catch (error) {
    return error;
  }
};

export const getSurgeonById = async (
  id: string,
  cancelToken?: CancelTokenSource['token']
): Promise<any> => {
  try {
    const endPoint = surgeonByIdRoute.replace(":surgeon_id", id)
    const response = await axios.get(endPoint, {cancelToken});
    return response.data;
  } catch (error) {
    return error;
  }
};

export const updateSurgeonPreferences = async (
  id: string,
  preferences: string,
  removeProfilePhoto: boolean
): Promise<any> => {
  try {
    const endPoint = updateSurgeonPreferencesRoute.replace(":surgeon_id", id)
    const response = await axios.put(endPoint, {
      remove_profile_photo: removeProfilePhoto,
      preferences
    });
    return response.data;
  } catch (error) {
    return error;
  }
};

export const updateSurgeonProfilePic = async (
  id: string,
  file: any
): Promise<any> => {
  try {
    const endPoint = profilePictureRoute.replace(":surgeon_id", id)
    const response = await axios.put(endPoint, file, {
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      timeout: 180000
    });
    return response.data;
  } catch (error) {
    return error;
  }
};

export const getSurgeonProfilePicture = async (id: string): Promise<any> => {
  const endPoint = profilePictureRoute.replace(":surgeon_id", id)
  const response = await axios.get(endPoint, {
    timeout: 180000
  });
  return response.data;
};

export const deleteSurgeon = async (id: string): Promise<any> => {
  try {
    const response = await axios.delete(surgeonByIdRoute);
    return response.data;
  } catch (error) {
    return error;
  }
};

export const getServiceLines = async (): Promise<any> => {
  const response = await axios.get(getServiceLinesRoute, {
    timeout: 180000
  });
  return response.data;
};